import { CustomButton } from "../../core/shared/grid/grid.model";

export class StructureUserRole {
    guid: string;
    name: string;
}

export class StructureUser {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    roleId: string;
    role: string;
    superiorId: string;
    superior: string;
    name: string;
    password: string;
    repeatedPassword: string;
    isActive: boolean;
    // fullName: string;
}

export class ResetPasswordButton implements CustomButton {

    getButtonClass(row: any): {} {
        return "btn btn-primary pull-right btn-sm";
    }    
    hasIcon: boolean = true;
    displayName: string = '';
    getIconClass(row: any): {} {
        return "ace-icon fa fa-key icon-only";
    }
    actionName: string = 'onResetPassword';
    isDisabled(row: any): boolean {
        return false;
    }
    isVisible(row: any): boolean {
        return true;
    }
    getTooltipText(row: any): string {
        return "Reset user password";
    }
}

export class ReactivateUserButton implements CustomButton {

    getButtonClass(row: any): {} {
        return "btn btn-success pull-right btn-sm";
    }    
    hasIcon: boolean = true;
    displayName: string = '';
    getIconClass(row: any): {} {
        return "ace-icon fa fa-id-badge icon-only";
    }
    actionName: string = 'onReactivateUser';
    isDisabled(row: any): boolean {
        return row.isActive === 'True';
    }
    isVisible(row: any): boolean {        
        return row.isActive === 'False';
    }
    getTooltipText(row: any): string {
        return "Reactivate user"
    }
}

export class DeactivateUserButton implements CustomButton {

    getButtonClass(row: any): {} {
        return "btn btn-danger pull-right btn-sm";
    }    
    hasIcon: boolean = true;
    displayName: string = '';
    getIconClass(row: any): {} {
        return "ace-icon fa fa-id-badge icon-only";
    }
    actionName: string = 'onDeactivateUser';
    isDisabled(row: any): boolean {
        return row.isActive === 'False';
    }
    isVisible(row: any): boolean {        
        return row.isActive === 'True';
    }
    getTooltipText(row: any): string {
        return "Deactivate user"
    }
}